import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from "tss-react/mui";
import styles from '../shellStyles';
import ProgressDialog from 'components/ProgressDialog';
import PromptDialog from 'components/PromptDialog';
import LocationDialog from 'areas/location/components/LocationDialog';
import CardHolderView from 'areas/cards/components/CardHolderView';
import { processCard } from 'areas/cards/domain';
import { Body1 } from 'components/Typography';
import AppBar from '../AppBar';
import PendingCompetenciesDialog from 'areas/competence/components/PendingCompetenciesDialog';
import CompetencyRequirementsDialog from 'areas/competence/components/CompetencyRequirementsDialog';
import alertActions from 'areas/alert/actions';
import classNames from 'classnames';
import { openLocationDialog, closeLocationDialog } from 'areas/supervisor/actions';
import signout from 'areas/auth/actions/signout';
import repository from 'client/repository';
import displayMode from 'areas/swipes/domain/displayMode';
import logService, { removeFields } from 'utilities/logging/logService';

class AppView extends React.Component {

    constructor(props) {
        super(props);
        if (this.props.longTitle) {
            document.title = this.props.longTitle;
        }
    }
    state = {
        menuOpen: false,
        cardShown: false,
        cardLoading: false,
        cardToShow: null,
        competencyRequirementsOpen: false
    };

    componentDidMount() {
        if (this.props.longTitle) {
            document.title = this.props.longTitle;
        }
    }

    onMenuClicked = () => {
        this.setState({ menuOpen: true });
    };

    onClosePrompt = () => {
        this.props.clearAlert();

        if (this.props.messageCallback) {
            this.props.messageCallback();
        }
    };

    handleLocationClicked = () => {
        this.props.openLocationDialog();
    };

    handleShowCardClicked = async () => {

        this.setState({ cardLoading: true });

        try {
            const card = await repository.cards.getCardDataByQR(repository.auth.getQRCode(), true, true);
            card.cardData.dateRetrieved = new Date().toISOString();
            const { location, supervisor, config } = this.props;
            const processedCard = processCard(card, location, supervisor, config);

            const reducedCardData = removeFields(processCard);

            logService.info('show card checker card', reducedCardData);

            this.setState({ cardShown: true, cardToShow: processedCard, cardLoading: false });
        }
        catch (e) {
            this.setState({ cardLoading: false });
        }
    };

    handleCompetencyRequirementsClicked = () => {
        this.setState({ competencyRequirementsOpen: true });
    };

    closeCompetencyRequirementsClicked = () => {
        this.setState({ competencyRequirementsOpen: false });
    };

    closeCardholderView = () => {
        this.setState({ cardShown: false });
    };

    handleLocationClose = () => {
        this.props.closeLocationDialog();
    };

    handleSignOut = () => {
        this.props.signout(repository.auth.getQRCode());
    };

    render() {
        let {
            classes,
            card,
            config,
            message,
            isLoggedOn,
            progressOpen,
            location,
            progressMessage,
            locationDialogOpen,
            longTitle,
            shortTitle
        } = this.props;

        let showDialogPrompt = (message && message.length > 0);
        let shouldHideNavigation = Boolean(this.props.hideNavigation);

        if (!progressOpen && this.state.cardLoading) {
            progressOpen = true;
            progressMessage = "Loading card details";
        }

        return (
            <div>
                <PendingCompetenciesDialog />

                <LocationDialog
                    title="Change Location"
                    canCancel={true}
                    handleClose={this.handleLocationClose}
                    open={!!locationDialogOpen} />

                <CompetencyRequirementsDialog
                    open={this.state.competencyRequirementsOpen}
                    handleClose={this.closeCompetencyRequirementsClicked} />

                <div className={classes.root}>
                    {this.props.appBar ||
                        <AppBar
                            longTitle={longTitle}
                            shortTitle={shortTitle}
                            menuVisible={isLoggedOn && !shouldHideNavigation}
                            onMenuClicked={this.onMenuClicked}
                            onLogOutClicked={this.handleSignOut}
                            onLocationClicked={this.handleLocationClicked}
                            onShowCardClicked={this.handleShowCardClicked}
                            onCompetencyRequirementsClicked={this.handleCompetencyRequirementsClicked}
                            cardCheckerCard={card}
                            config={config}
                            {...this.props.AppBarProps}
                        />
                    }
                    {this.state.cardShown &&
                        <CardHolderView
                            open={this.state.cardShown}
                            card={this.state.cardToShow}
                            location={location}
                            config={config}
                            close={this.closeCardholderView}
                            title={`${card.firstname} ${card.surname}`}
                            editable={false}
                            viewcontext={displayMode.none}
                        />
                    }

                    <main className={classNames(classes.content, this.props.contentClass || '')}>
                        <div className={classes.toolbar} />
                        <Body1 component="div">
                            {this.props.children}
                        </Body1>
                    </main>
                </div>

                {/* General purpose progress dialog */}
                <ProgressDialog open={progressOpen} className={classes.progressDialog}>
                    {progressMessage}
                </ProgressDialog>

                <PromptDialog
                    open={!!showDialogPrompt}
                    message={message}
                    confirmClicked={this.onClosePrompt}
                    confirmText="Close"
                    showCancel={false} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { alert, auth, cards, config, progress, location, supervisor } = state;

    const cardCheckerCard = repository.auth.getLoggedOnCardDetails(cards.cards);

    return {
        longTitle: config.appName,
        shortTitle: config.shortAppName,
        message: alert.message,
        messageCallback: alert.callback,
        isLoggedOn: auth.loggedIn,
        messageType: (alert.type || "").toLowerCase(),
        progressOpen: progress.open,
        progressMessage: progress.message,
        locationDialogOpen: supervisor.locationDialogOpen,
        supervisor: supervisor,
        location,
        config,
        card: processCard(cardCheckerCard, location, supervisor, config)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openLocationDialog: () => dispatch(openLocationDialog()),
        closeLocationDialog: () => dispatch(closeLocationDialog()),
        clearAlert: () => dispatch(alertActions.clear()),
        signout: (qrCode) => dispatch(signout(qrCode))

    };
}

const styledAppView = withStyles(AppView, styles);
const connectedAppView = connect(mapStateToProps, mapDispatchToProps)(styledAppView);

export default connectedAppView;